export const commonTranslations = {
  pt: {
    loading: "Carregando...",
    error: "Ocorreu um erro",
    success: "Sucesso",
    unsaved: "Não salvo"
  },
  en: {
    loading: "Loading...",
    error: "An error occurred",
    success: "Success",
    unsaved: "Not saved"
  }
};
